/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stealth_Access_LabelInputs */



/**
* | output |
* | --- |
* | "Your work email" |
*
* @param {Stealth_Access_LabelInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const stealth_access_label = /** @type {((inputs?: Stealth_Access_LabelInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stealth_Access_LabelInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Your work email")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Din jobbmejl")
	return /** @type {LocalizedString} */ ("Din jobb-e-post")
});